class CacheService {
    constructor($rootScope) {
        const cacheEnabledState = [
            'shop.browse',
            'shop.offergroup',
            'shop.productgroup',
            'shop.search',
            'shop.specials',
            'shop.productdetails'
        ];

        let _cache = {};
        let _cacheBanners = {};

        this.set = function (key, value) {
            _cache[key.toLowerCase()] = value;
        };

        this.get = function (key) {
            if (key.toLowerCase() in _cache) {
                return _cache[key.toLowerCase()];
            }

            return null;
        };

        this.pop = function (key) {
            const rs = this.get(key);

            if (rs != null) {
                delete _cache[key.toLowerCase()];
            }

            return rs;
        };

        this.clearCache = function () {
            _cache = {};
        };

        // below set of functions for manage banners cache
        this.setBannerCache = function (key, value) {
            _cacheBanners[key.toLowerCase()] = value;
        };

        this.getBannerCache = function (key) {
            if (key.toLowerCase() in _cacheBanners) {
                return _cacheBanners[key.toLowerCase()];
            }
            return null;
        };

        this.popBannerCache = function (key) {
            const rs = this.getBannerCache(key);

            if (rs != null) {
                delete _cacheBanners[key.toLowerCase()];
            }

            return rs;
        };

        this.clearBannerCache = function () {
            _cacheBanners = {};
        };

        $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState) => {

            let i = 0;
            for (i = 0; i < cacheEnabledState.length; i++) {
                const found = toState.name.indexOf(cacheEnabledState[i]);
                if (found !== -1) {
                    return;
                }
            }

            if (toState.name !== fromState.name) {
                this.clearCache();
            }
        });
    }
}

module.exports = CacheService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/cacheservice/cache-service.js
 **/